import { useMemo } from 'react'
import { useOrionDomainQuery } from '../../../../../../api/coreData'
import { transformSeriesResponse } from './transformSeriesResponse'

// React Query wrapper for the trend tool. Reuses the grid's existing
// orion/domain-query cache namespace; each unique request body is cached
// independently, so toggling chart type (which changes `cumulative` and
// produces a different request) caches separately and toggling back is
// instant.
//
// `unwrap` (when set, virtual-grouping row scope) carries the row's
// identity so transformSeriesResponse can pick the matching sibling
// group out of the response -- the `string-equal` filter we wrap the
// request in doesn't actually constrain Orion's output, it just
// scopes the series calc to a grouping level.
//
// Returns `seriesByCalcId` (a plain object keyed by the calc id baked
// into each request calc, e.g. `trend_0`, `trend_1`). The tool maps
// its in-memory `series` state to results via `calcIds[i]`.
export function useTrendQuery ({ request, clientId, unwrap }) {
  const queryResult = useOrionDomainQuery(
    'reporting/scope',
    clientId,
    request,
    { enabled: !!request && !!clientId }
  )

  const { data: rawData, isFetching, error, refetch } = queryResult

  const { seriesByCalcId } = useMemo(
    () => transformSeriesResponse(rawData, { unwrap }),
    [rawData, unwrap]
  )

  return {
    seriesByCalcId,
    isFetching,
    error,
    refetch
  }
}
